import { GraphDto } from "@custom-types/graphs"
import { CircularProgress, Grid } from "@mui/material"
import { Graph } from "@features/builder/graph/Graph"
import { useGraphDocument } from "@features/builder/GraphDocumentProvider/hooks/useGraphDocument"
import { useGraphDocumentData } from "@features/builder/GraphDocumentProvider/hooks/useGraphDocumentData"
import GraphDisconnectedBackdrop from "@features/builder/GraphDisconnectedBackdrop"
import { useIsSocketConnected } from "@features/builder/hooks/useIsSocketConnected"
import { convertSocketGraphToReactFlow } from "@features/builder/graph/editGraphSocketConverter"
import { GraphNavigationDialog } from "@features/builder/GraphNavigationDialog"
import CreateEdgesDialog from "@features/builder/CreateEdges/CreateEdgesDialog"

export type EditModeProps = {
  graph: GraphDto | undefined
}

const EditMode = (props: EditModeProps) => {
  const graphDocument = useGraphDocument()
  const graphData = useGraphDocumentData()
  const { hadConnectionProblems, isSocketConnected } = useIsSocketConnected()

  const graphState = graphDocument ? convertSocketGraphToReactFlow(graphData) : null

  if (!graphState) {
    return (
      <Grid container alignContent="center" justifyContent="center" sx={{ height: "100%" }}>
        <Grid item>
          <CircularProgress />
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid
      container
      direction="column"
      sx={{
        height: "100%",
      }}
    >
      {hadConnectionProblems && !isSocketConnected && <GraphDisconnectedBackdrop />}
      <Graph nodes={graphState.nodes} edges={graphState.edges} graphId={props.graph?.key} />
      <CreateEdgesDialog />
      <GraphNavigationDialog />
    </Grid>
  )
}

export default EditMode
